import React from "react";

function KebijakanPengaduanTab() {

    return (
        <>
            <div className="container-publikasi-pengaduan publikasi-pengaduan">
                <div className="section-title text-center mb-4">
                    <h2 className="text-header">Kebijakan Penanganan Pengaduan Pengguna</h2>
                </div>
                <p>Berdasarkan Peraturan Otoritas Jasa Keuangan Nomor 2 Tahun 2023 tentang Pelindungan Konsumen dan
                    Masyarakat di Sektor Jasa Keuangan, Danai.id menyusun dan menerapkan kebijakan penanganan pengaduan.
                    Kebijakan ini bertujuan untuk memastikan terpenuhinya hak-hak konsumen secara adil dan akuntabel,
                    serta menjamin bahwa layanan jasa keuangan yang disediakan oleh Danai.id diselenggarakan secara
                    transparan, aman, nyaman, dan teratur.
                </p>
                <div className='self-start'>
                    <h4 className="mb-4" style={{color: '#272727'}}>Jalur Pengaduan Pengguna</h4>
                    <p className='mb-3'>Pengaduan dapat disampaikan melalui kanal resmi <em>Customer Service</em> Danai.id sebagai berikut:</p>
                    <ol className="list-disc">
                        <li>
                            <p className='mb-0 font-semibold'><em>Whatsapp Chat*</em></p>
                            <p className='mb-0'>
                                Hubungi kami melalui <em>Whatsapp Chat</em> di nomor <a className="whatsapp" href="https://wa.me/6281295927442"><b>(+62) 812 9592 7442</b></a>.
                            </p>
                        </li>
                        <li>
                            <p className='mb-0 font-semibold'>Telepon*</p>
                            <p className='mb-0'>Hubungi kami melalui layanan telepon di nomor <b>021 - 5010 3363</b>.</p>
                        </li>
                        <li>
                            <p className='mb-0 font-semibold'>Email</p>
                            <p className='mb-0'>Kirim pengaduan melalui email ke <a className='blue' href="mailto:customer.care@danai.id"><b>customer.care@danai.id</b></a>.</p>
                        </li>
                    </ol>
                    <p>*) Layanan ini tersedia pada hari dan jam kerja, yaitu <b>Senin–Jumat pukul 09.00–17.00 WIB, tidak termasuk Hari Libur Nasional.</b></p>
                </div>
                <div>
                    <h4 className="mb-4" style={{color: '#272727'}}>Waktu Penyelesaian Pengaduan</h4>
                    <p className="mb-3">Waktu penyelesaian pengaduan dapat bervariasi tergantung pada jenis pengaduan serta tingkat kompleksitas penanganan laporan yang diterima oleh Danai.id.</p>
                    <ol className="list-decimal">
                        <li>
                            <p className='mb-0 font-semibold'>Pengaduan Lisan</p>
                            <p className='mb-0'>Danai.id akan menindaklanjuti pengaduan yang disampaikan secara lisan
                                paling lama 10 (sepuluh) Hari Kerja sejak diterimanya laporan pengaduan. <br/>
                                Jika diperlukan, Danai.id dapat meminta dokumen pendukung tambahan dan mengarahkan
                                Konsumen agar menyampaikan pengaduan secara tertulis untuk melengkapi proses penanganan pengaduan.
                            </p>
                        </li>
                        <li>
                            <p className='mb-0 font-semibold'>Pengaduan Tertulis</p>
                            <p className='mb-0'>Danai.id akan menindaklanjuti pengaduan yang disampaikan secara tertulis
                                setelah menerima dokumen pendukung secara lengkap, dengan jangka waktu penyelesaian
                                paling lama 10 (sepuluh) Hari Kerja sejak diterimanya laporan pengaduan.</p>
                        </li>
                        <li>
                            <p className='mb-0 font-semibold'>Perpanjangan Masa Penanganan Pengaduan</p>
                            <p className='mb-0'>Penanganan pengaduan dapat diperpanjang paling lama 10 (sepuluh) Hari
                                Kerja, jika ada pertimbangan, antara lain : </p>
                            <ol className="list-[lower-alpha]">
                                <li className="mb-0">Diperlukan penelitian khusus dan/atau pendalaman lebih lanjut terhadap pengaduan yang disampaikan.</li>
                                <li className="mb-0">Terdapat kondisi atau hal-hal di luar kendali Danai.id.</li>
                            </ol>
                        </li>
                    </ol>
                </div>
                <div>
                    <h4 className="mb-4" style={{color: '#272727'}}>Penyelesaian Pengaduan</h4>
                    <p>Setelah laporan pengaduan diterima oleh Customer Service Danai.id, proses penanganan pengaduan akan dilaksanakan sesuai dengan prosedur operasional standar yang berlaku.
                        Tim terkait akan melakukan verifikasi data, analisis permasalahan, serta merumuskan solusi yang tepat dan proporsional sesuai dengan tingkat kompleksitas pengaduan.
                        Penyelesaian pengaduan dilakukan dalam jangka waktu yang ditentukan berdasarkan tingkat kompleksitas kasus, dengan tetap menjunjung tinggi prinsip transparansi, akuntabilitas, dan perlindungan konsumen
                        Informasi mengenai status penanganan pengaduan akan disampaikan kepada Konsumen melalui kanal komunikasi resmi Danai.id.
                    </p>
                </div>
            </div>
        </>
    );
}

export default KebijakanPengaduanTab;